"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function removeNonUTF8(str) {
    return str.replace(/[^\x00-\x7F]/g, '');
}
function encodeAndStringify(input) {
    return btoa(removeNonUTF8(JSON.stringify(input)));
}
exports.default = encodeAndStringify;
//# sourceMappingURL=encodeAndStringify.js.map